export type TrialWelcomeOutcome = { email_sent?: boolean; whatsapp_sent?: boolean; skipped?: string; errors?: string[] };
export function trialProvisionOutcome(data: { org_id?: string; welcome?: TrialWelcomeOutcome }) {
  if (!data.org_id) throw new Error('Organization was not created');
  const welcome = data.welcome;
  if (welcome?.skipped) return `Organization created. Welcome skipped: ${welcome.skipped}.`;
  if (welcome?.email_sent && welcome.whatsapp_sent) return 'Organization created. Welcome email and official WhatsApp sent.';
  return `Organization created. Welcome: email ${welcome?.email_sent ? 'sent' : 'not sent'}, WhatsApp ${welcome?.whatsapp_sent ? 'sent' : 'not sent'}. ${(welcome?.errors ?? ['welcome result unavailable']).join('; ')}`;
}
